<ul class="list-group" style='cursor: pointer; user-select: none;'>
  @if (clickInfo.type == 'feature') {
    <li (click)="focusOn()"
      class="list-group-item list-group-item-action">
      Focus on {{clickInfo?.data?.name}}
    </li>
  }
  @if (clickInfo?.data?.type != 'view' && sceneNotProcessing) {
    <li (click)="copy()"
      class="list-group-item list-group-item-action">
      Copy {{clickInfo?.data?.name}}
    </li>
  }
  @if (clickInfo?.data?.type != 'view' && sceneNotProcessing) {
    <li (click)="duplicate()"
      class="list-group-item list-group-item-action">
      Duplicate {{clickInfo?.data?.name}}
    </li>
  }
  @if (clickInfo?.data?.type == 'group') {
    <li (click)="ungroup()" class="list-group-item list-group-item-action">
      Ungroup {{clickInfo?.data?.name}}
    </li>
  }
  @if (clickInfo.type == 'feature' && clickInfo?.data.parentID) {
    <li (click)="removeFromGroup(clickInfo.data)"
      class="list-group-item list-group-item-action">
      Remove {{clickInfo?.data?.name}} from Group
    </li>
  }
  <li (click)="delete()" class="list-group-item list-group-item-action list-group-item-danger">
    Delete {{clickInfo?.data?.name}}
  </li>
</ul>